import { ExternalLink } from "lucide-react";
import { Reveal } from "../Reveal";
import { ReviewBadge } from "../ReviewBadge";
import { StatTiles } from "../StatsBand";
import { CONTACT } from "../../data/content";

const StarIcon = ({ className, style }) => (
  <svg viewBox="0 0 24 24" className={className} style={style} aria-hidden><path d="M12 1.5 C12.8 7.5 16.5 11.2 22.5 12 C16.5 12.8 12.8 16.5 12 22.5 C11.2 16.5 7.5 12.8 1.5 12 C7.5 11.2 11.2 7.5 12 1.5 Z" fill="currentColor" /></svg>
);

export const PoweredBand = () => (
  <section data-testid="about-powered" className="relative isolate overflow-hidden bg-[#0B0B0B] py-20 text-white lg:py-28">
    <div aria-hidden className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
      <div className="hero-blob absolute left-[-10%] top-[-30%] h-[50vw] max-h-[560px] w-[50vw] max-w-[560px] rounded-full bg-en-teal/25 blur-3xl" />
      <div className="hero-blob absolute bottom-[-40%] right-[-10%] h-[50vw] max-h-[560px] w-[50vw] max-w-[560px] rounded-full bg-en-yellow/15 blur-3xl" style={{ animationDelay: "-9s" }} />
      <StarIcon className="glow-star absolute right-[8%] top-10 hidden w-10 text-en-yellow md:block" style={{ "--d": "-1s", "--t": "3.4s" }} />
      <StarIcon className="glow-star absolute left-[6%] top-[40%] hidden w-6 text-en-yellow md:block" style={{ "--d": "-2.2s", "--t": "2.8s" }} />
      <StarIcon className="glow-star absolute bottom-10 right-[30%] hidden w-7 text-white md:block" style={{ "--d": "-0.6s", "--t": "3.9s" }} />
    </div>
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-12 lg:items-center">
        <Reveal className="lg:col-span-6">
          <p className="eyebrow mb-4 !text-en-yellow">Powered by Trivia Nation</p>
          <h2 className="font-display text-3xl leading-[1.05] sm:text-4xl lg:text-5xl">Two decades of live shows. One sister company.</h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-white/75 sm:text-lg">Entertainment Nation brings the proven formats, professional hosting and crowd engagement that built Trivia Nation's reputation to companies, clubs, communities, charities and private celebrations.</p>
          <a href={CONTACT.triviaNation} target="_blank" rel="noreferrer" data-testid="powered-trivia-nation-link" className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/25 px-6 py-3 font-gothic text-sm uppercase tracking-wider text-white transition-colors hover:border-en-yellow hover:text-en-yellow">Visit trivianation.com <ExternalLink className="h-4 w-4" /></a>
        </Reveal>
        <Reveal delay={0.15} className="rounded-3xl border border-white/10 bg-white p-8 text-black lg:col-span-6 lg:p-10">
          <ReviewBadge size="hero" testId="about-powered-review-badge" />
        </Reveal>
      </div>
      <div className="mt-14">
        <StatTiles dark />
        <p className="mt-6 text-sm text-white/50" data-testid="powered-attribution">Across the Trivia Nation family — the team behind Entertainment Nation.</p>
      </div>
    </div>
  </section>
);
